// extracted by mini-css-extract-plugin
export default {"helpIcon":"FeeIcon_helpIcon__G0kJV"};